import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-potral-configuration',
  templateUrl: './potral-configuration.component.html',
  styleUrls: ['./potral-configuration.component.scss']
})
export class PotralConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
